import React from "react";
import "./Synonyms.css";

export default function Synonyms(props) {
  let synonyms = props.synonyms;
  let size = 7;

  let items = (
    <div>
      {synonyms.slice(0, size).map(function (synonym, index) {
        return (
          <button
            type="button"
            onClick={getButtonText}
            className="btn btn-sm px-2"
            key={index}
          >
            {synonym}
          </button>
        );
      })}
    </div>
  );

  function getButtonText(event) {
    let term = event.target.innerHTML;
    props.childToParent(term);
  }

  if (synonyms) {
    return (
      <div className="Synonyms d-flex justify-content-start">
        <div className="row">
          <div className="col">{items}</div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
